import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "w-full bg-fite flex gap-4 py-6 px-4",
  method: "get",
  action: "/search/",
  ref: "search-form"
}
const _hoisted_2 = { class: "relative flex grow" }
const _hoisted_3 = {
  key: 0,
  class: "p-4 gap-2"
}

import {computed, nextTick, onMounted, ref, watch} from "vue"
import {useStore} from "./store";
import SearchButton from "./components/SearchButton.vue";
import ResultItem from "./components/ResultItem.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();

const open = ref(false);
const widget = ref(null);
const search = ref(null);
const selected = ref(-1)

const dark = computed(() => {
    if (store.query.length > 0 && store.searchResults.length === 0){
        return true;
    }else if (!store.trending && !store.searchResults){
        return true;
    }
    return false;
})

const resultItems = computed(() => {
    if (store.query.length > 0){
        return store.searchResults
    }else{
        return store.trending
    }
})
const clickHandled = () => {
    toggleSearch()
}
const searchHandler = () => {
    if (store.query.toString().trim().length >= 3){
        location.href = `/search/?q=${encodeURIComponent(store.query.toString().trim())}`
        toggleSearch()
    }
}
const toggleSearch = () => {
    open.value = !open.value;
}

function _handleClickOutside(ev) {
    const clickedEl = ev.target;
    if (widget && !widget.value.contains(clickedEl) &&  open.value) {
        toggleSearch();
    }
}

function _handleKeyDown(ev) {
    if (!open.value){
        return;
    }
    if (ev.keyCode === 27){
        toggleSearch()
    }else if(ev.keyCode === 38){
        if (selected.value > -1){
            selected.value = selected.value-1;
        }
        ev.preventDefault();
    }else if(ev.keyCode === 40){
        if (resultItems.value && resultItems.value.length - 1 > selected.value){
            selected.value = selected.value + 1;
        }
        ev.preventDefault();
    }else if(ev.keyCode === 13){
        if (selected.value === -1 && store.query.toString().trim().length >= 3){
            location.href = `/search/?q=${encodeURIComponent(store.query.toString().trim())}`;
            toggleSearch();
        }else if (selected.value !== -1) {
            try{
                const item = resultItems.value[selected.value];
                let goToUrl = ""
                if (item?.type === "video"){
                    goToUrl = `/v/${item.videoId}`;
                }else if (item.result){
                    goToUrl = `/search/?q=${encodeURIComponent(item.result)}`
                }else{
                    console.log("nothing")
                }

                if (goToUrl){
                    location.href = goToUrl;
                    toggleSearch()
                }
            }catch (e){
                console.log(e)
            }

        }
        ev.preventDefault();
    }
}

watch(() => open.value, (value) => {
    if (value){
        selected.value = -1;
        nextTick().then(() => {
            search.value.focus();
        })
    }
})

watch(() => store.query, () => {
    selected.value = -1;
    store.fetchSearch()
})

onMounted(() => {
    document.body.addEventListener('click', _handleClickOutside, true);
    document.addEventListener('keydown', _handleKeyDown);
    store.fetchTrending();
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SearchButton, { onClick: clickHandled }),
    _createElementVNode("div", {
      class: _normalizeClass([{hidden: !open.value}, "absolute top-0 right-0 md:right-4 xl:right-18 w-full md:w-96 nav-search"]),
      ref_key: "widget",
      ref: widget
    }, [
      _createElementVNode("form", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createElementBlock("svg", {
            class: "absolute left-2 top-2 sm:top-1 search-icon w-6 h-6 cursor-pointer",
            fill: "currentColor",
            onClick: searchHandler
          }, _cache[1] || (_cache[1] = [
            _createElementVNode("use", { "xlink:href": "#search-icon" }, null, -1)
          ]))),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(store).query) = $event)),
            ref_key: "search",
            ref: search,
            id: "search-query",
            name: "q",
            autocomplete: "off",
            class: "grow pl-10 py-2 pr-2 bg-fite-gray-800 rounded-3xl text-base sm:text-xs",
            type: "text",
            placeholder: "Events, fighters, channels and more..."
          }, null, 512), [
            [_vModelText, _unref(store).query]
          ])
        ]),
        _createElementVNode("input", {
          onClick: clickHandled,
          class: "text-sm font-normal font-sans text-mono-ps-100 hover:text-mono-white",
          type: "button",
          value: "Cancel"
        })
      ], 512),
      _createElementVNode("div", {
        class: _normalizeClass([{'bg-mono-white': !dark.value, 'bg-fite': dark.value}, "text-sm text-fite-gray-60 rounded-bl-lg rounded-br-lg"])
      }, [
        (resultItems.value)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resultItems.value, (item, index) => {
                return (_openBlock(), _createBlock(ResultItem, {
                  key: index,
                  "result-type": item.type,
                  index: index,
                  "thumbnail-url": item.thumbnailUrl,
                  "result-id": item.videoId,
                  "display-result": item.displayResult,
                  result: item.result,
                  "copy-result": item.copyResult,
                  selected: index == selected.value
                }, null, 8, ["result-type", "index", "thumbnail-url", "result-id", "display-result", "result", "copy-result", "selected"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ], 2)
  ], 64))
}
}

})